import { render, staticRenderFns } from "./ProjectBrandManagement.vue?vue&type=template&id=627315f4&scoped=true&"
import script from "./ProjectBrandManagement.vue?vue&type=script&lang=js&"
export * from "./ProjectBrandManagement.vue?vue&type=script&lang=js&"
import style0 from "./ProjectBrandManagement.vue?vue&type=style&index=0&id=627315f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627315f4",
  null
  
)

export default component.exports